import React from 'react';
import PropTypes from 'prop-types';
import AddressFieldItem, { addressFieldProp } from './AddressFieldItem';

const propTypes = {
  fields: PropTypes.arrayOf(addressFieldProp).isRequired,
  onChange: PropTypes.func.isRequired,
  addressFormData: PropTypes.shape({}),
};

export default function AddressFields(props) {
  const { fields, addressFormData, onChange } = props;

  return fields.map((field) => (
    <AddressFieldItem
      key={`FIELD_${field.id}`}
      field={field}
      value={addressFormData?.[field.id]}
      onChange={onChange}
    />
  ));
}

AddressFields.propTypes = propTypes;
AddressFields.defaultProps = {};
